import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-[#0f0a1a] text-gray-300">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <Link to="/" className="inline-flex items-center gap-2 text-pink-400 hover:text-pink-300 mb-8" data-testid="privacy-back-link">
          <ArrowLeft className="w-4 h-4" /> Back to Home
        </Link>
        <h1 className="text-3xl font-bold text-white mb-2">Privacy Policy</h1>
        <p className="text-gray-500 text-sm mb-8">Last updated: January 1, 2025</p>

        <div className="space-y-6 leading-relaxed text-sm">
          <section>
            <h2 className="text-lg font-semibold text-white mb-2">1. Information We Collect</h2>
            <p>When you use our website, we may collect the following information:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-gray-400">
              <li>Personal information you provide during registration (name, email address, profile picture) via Google OAuth.</li>
              <li>Payment information processed securely through Stripe. We do not store your credit card details.</li>
              <li>Usage data such as pages visited, time spent on the site, and interaction patterns.</li>
              <li>Device information including browser type, IP address, and operating system.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">2. How We Use Your Information</h2>
            <ul className="list-disc list-inside space-y-1 text-gray-400">
              <li>To provide and maintain our services, including course access and book purchases.</li>
              <li>To process transactions and send purchase confirmations.</li>
              <li>To send welcome emails and important service updates.</li>
              <li>To improve our website and user experience.</li>
              <li>To comply with legal obligations.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">3. Data Sharing</h2>
            <p>We do not sell or rent your personal information to third parties. We may share data with:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-gray-400">
              <li>Payment processor (Stripe) to complete transactions.</li>
              <li>Email service providers to send transactional emails.</li>
              <li>Law enforcement if required by law.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">4. Data Security</h2>
            <p>We implement appropriate security measures to protect your personal information. All data transmissions are encrypted using SSL/TLS. However, no method of transmission over the internet is 100% secure.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">5. Your Rights</h2>
            <p>You have the right to access, correct, or delete your personal data. To exercise these rights, please contact us through the provided contact channels.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">6. Contact Us</h2>
            <p>If you have questions about this Privacy Policy, please reach out via WhatsApp at <a href="https://wa.me/963988242654" className="text-green-400 hover:text-green-300">+963 988 242 654</a>.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
